export const isLocaleActive = (currentLocale: string, targetLocale: string): boolean => {
  return currentLocale === targetLocale
}
